import { SEARCH_MODE } from "@src/constants";

export const allowFacilityDetailsSearchModes = [SEARCH_MODE.WORKER_AVAILABILITY];
export const INVISIBLE_SHIFT_FILTER_SEARCH_MODES = [SEARCH_MODE.WORKER_AVAILABILITY];
export const CUSTOM_FACILITY_SHIFT_FILTER_DATA_SEARCH_MODES = [SEARCH_MODE.WORKER_AVAILABILITY];
